module.exports = __webpack_public_path__ + "static/media/MamaPayFooter.a58dab1b.jpg";